/**
 * @prettier
 */
import { Apps } from 'src/constants/App';
import type { OrderVm } from 'src/types/OrderVm';

export function isApiOrder(order: OrderVm): boolean {
    return order.app === Apps.PIDEDIRECTO_API;
}
